import React from 'react';
import {FieldsRendererProps} from '../FieldsRenderer';
import {Grid} from '@mui/material';
import {Stack} from '@mui/material';
import {AppControlledDatePicker} from 'components/form';

interface RenderDatePickerProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderDatePicker: React.FC<RenderDatePickerProps> = ({control, field, baseFieldName, gridSize}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledDatePicker
                    label={field.title}
                    control={control}
                    defaultValue={null}
                    required={field.isRequired}
                    name={`${baseFieldName}.value`}
                />
            </Stack>
        </Grid>
    );
};

export default RenderDatePicker;
